import React from 'react';
import { BaasicDropzone, BaasicButton } from 'core/components';
import { defaultTemplate } from 'core/hoc';

function OrderImportTemplate({ marketplaceOrderListViewStore, t }) {
	var uploadType = '.xls, .xlsx, .csv, text/plain';

	const modalTitle = t('ORDERVIEW.IMPORTORDERS');
	return (
		<section className="ReactModal__form">
			<div>
				<h3 className="ReactModal__header">{t(modalTitle)}</h3>
			</div>
			<div className="ReactModal__body">
				<button
					type="button"
					className="btn btn--med btn--primary btn--primary--negative"
					onClick={() => marketplaceOrderListViewStore.downloadExcelTemplate()}
				>
					<i className="fa fa-download spc--right--sml"></i>
					{t('PRODUCTVIEW.DOWNLOADEXCELTEMPLATE')}
				</button>
			</div>
			<div className="ReactModal__body">
				<BaasicDropzone acceptFiles={uploadType} onFilesDrop={marketplaceOrderListViewStore.onFilesDrop} />
			</div>
		</section>
	);
}

OrderImportTemplate.propTypes = {};

export default defaultTemplate(OrderImportTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/OrderImportTemplate.jsx